import * as $ from "jquery";
import * as ko from "knockout";
import { Command } from "../command";
import { CommandType } from "../commandType";
import { PopupType } from "../popups/popupType";
import { Application } from "../application";
import { EstimateSaveAsPopupParams } from "../../components/estimate-save-as-popup/estimate-save-as-popup";


export class OpenEstimateSaveAsPopupCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.OpenEstimateSaveAsPopup;

    canExecute = ko.computed(() => {
        let estimate = this.app.state.estimate();

        if(!estimate)
            return false;

        return true;
    });
    
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let estimate = this.app.state.estimate();

        let params = <EstimateSaveAsPopupParams> {
            id: estimate!.id(),
            name: estimate!.name()
        };

        return this.app.popupsManager.show<EstimateSaveAsPopupParams>(PopupType.estimateSaveAs, true, params).done(() => {
            let estimate = this.app.state.estimate();
            if (estimate && estimate.id() == params.id) {
                estimate.name(params.name);
            }
        });
    }

    name = "Save as estimate";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/openEstimateSaveAsPopupCommand.ts